export default __webpack_public_path__ + "assets/fa8441f345d83a0bc4ec345a6948dbb0.ttf";